import { HierarcicalObjectReference } from "@novorender/data-js-api";

import { ListNode, Node, Tree } from "components/objectTree/types";

export type ModelTreeFilterObjects = {
    type: ModelTreeFilter;
    objects: HierarcicalObjectReference[];
};

export type ModelTreeNodeData = {
    object: HierarcicalObjectReference;
    childIterator?: AsyncIterableIterator<HierarcicalObjectReference>;
};

export type TreeNodeRendererProps = {
    item: ListNode<ModelTreeNodeData>;
    setLoading: (value: boolean) => void;
    onToggleExpanded: (item: ListNode<ModelTreeNodeData>, node?: Node<ModelTreeNodeData>) => void;
    onExpandGroup: (node: ListNode<ModelTreeNodeData>) => void;
    onLoadMore: (node: ListNode<ModelTreeNodeData>) => void;
    onNodeRightClick?: (x: number, y: number, item: ListNode<ModelTreeNodeData>) => void;
    abortSignal: AbortSignal;
    highlightPath?: string;
    tree?: Tree<ModelTreeNodeData>;
    filteredObjectIds?: Set<number> | null;
    searchTerm?: string;
};

export enum ModelTreeFilterType {
    ParserType,
    Terrain,
}
export type ModelTreeFilter =
    | { type: ModelTreeFilterType.Terrain }
    | { type: ModelTreeFilterType.ParserType; parserType: string };
